export class CompSearchJuristictionColumns {
  key: string;
  label: string;
}
